import * as React from 'react';
import { UIText1 } from '@cian/ui-kit';
import * as styles from './Header.css';

export interface IHeaderProps {
  title?: string;
}

export const Header: React.FC<IHeaderProps> = ({ title }) => {
  return (
    <div className={styles['container']}>
      <UIText1 color="theme-white">{title}</UIText1>
    </div>
  );
};
